export default "__VITE_ASSET__CWfUuwar__"